import { handleFormError } from 'assets/js/misc';

angular.module('logbook')
  .controller('user-settings', ['$scope', '$http', '$rootScope', '$route', '$q', '$timeout', 'logService', 'appStateService',
      function($scope, $http, $rootScope, $route, $q, $timeout, logService, appStateService) {
      
        $scope.hasDefaultDialogSettings = () => {
            return appStateService.preferences.hasValue('default-popup-prefs');
        }
        
        $scope.deleteDialogPrefs = () => {
            appStateService.preferences.clearValue('default-popup-prefs');
        }
      
        $scope.defaultLogId = -1;
        $scope.refreshEmails = function() {
           return $http.get('/api/logBookUserEmails', {
              params: {
                 'size':1000,
                 'userDetails':$rootScope.user.id
              }
           }).then(function(result) {
              $scope.emails = result.data._embedded.logBookUserEmails;
           });
        };
        
        $scope.hasExclusiveLogin = false;
        
        $scope.refreshLogins = function() {
           return $http.get('/api/logBookUserLogins', {
              params: {
                 'size':1000,
                 'userDetails':$rootScope.user.id
              }
           }).then(function(result) {
              $scope.logins = result.data._embedded.logBookUserLogins;
              $scope.logins.forEach(function(login) {
                 if( login.loginProvider.exclusive )
                    $scope.hasExclusiveLogin = true;
              });
           });
        };
        
        $scope.getLogs = () => {
			return logService.getLogs().toPromise().then(logs => {
				$scope.logs = [{id: -1, name: 'No Default', default: true}].concat(logs);
			})
        }
        
        $q.all([
           $http.get('/api/logBookUsers/'+$rootScope.user.id),
           $http.get('/api/logBookUserDetails/'+$rootScope.user.id),
           $scope.refreshLogins(),
           $scope.getLogs()
        ])
		.then(results => {
           $scope.user = results[0].data;
           $scope.userDetails = results[1].data;
		   $scope.themeChanged = $scope.userDetails.config.theme != appStateService.selectedTheme;
		   $scope.userDetails.config.theme = appStateService.selectedTheme;
           $scope.defaultLogId = parseInt($scope.userDetails.config.defaultLog) || -1;
           $scope.defaultNoteEntry = validateNoteControlType($scope.userDetails.config.defaultNoteEntry);
		   $scope.themes = ['Light', 'Dark', 'Default'].map(theme => ({
		   	   name: theme,
		   	   value: theme
		   }));
			
           if ($scope.defaultLogId !== -1 && $scope.logs.findIndex(log => log.id === $scope.defaultLogId) === -1)
				$scope.defaultLogId = -1;
			
           $scope.initFields();
		});
		  
        $scope.refreshEmails();
        
        $scope.resetNewEmail = function() {
           $scope.newEmail = {};
        };
        
        $scope.setNewEmailField = function(field, $data) {
           $scope.newEmail[field] = $data;
        };
        
        $scope.submit = function() {
           delete $scope.userDetails.extendedData;
		   
           $q.all([
              $http.put($scope.user._links.self.href, $scope.user),
              $http.put($scope.userDetails._links.self.href, $scope.userDetails)
              ])
			  .then(function() {
				 $scope.themeChanged = false;
                 $scope.userFormDone = true;
                 $scope.userForm.$setPristine();
                 $scope.authenticate();
                 $timeout(function() {
                    $scope.userFormDone=false;
                 }, 5000);
              });
        }
        
        $scope.reload = function() {
           $route.reload();
        }
        
        $scope.addEmail = function() {
           var d = $q.defer();
           $http.post('/api/logBookUserEmails', {
              email: $scope.newEmail.newEmail,
              userDetails: $scope.userDetails._links.self.href 
           }, {
              'noErrorPopup': true,
              'rawError': true
           }).then(function() {
              d.resolve();
              $scope.refreshEmails().then(function() {
                 $scope.emails.forEach(function(email) {
                    if( email.email.toLowerCase() == $scope.newEmail.newEmail.toLowerCase())
                       email.verificationPending = true;
                 });
              });
           }, function(errors) {
              handleFormError(d, $scope.newEmailForm, errors);
           });
           return d.promise;
        };
        
        $scope.verifyEmail = function(email) {
           $http.patch(email._links.self.href, {
              "sendVerifyEmail": true
           }).then(function() {
              email.verificationPending = true;
           });
        };
        
        $scope.deleteEmail = function(email) {
           $http.delete(email._links.self.href).then(function() {
              $scope.refreshEmails();
           })
        };
        
        $scope.deleteLogin = function(login) {
           $http.delete(login._links.self.href).then(function() {
              $scope.refreshLogins();
           });
        };
        
        $scope.updateTheme = function() {
			appStateService.selectedTheme = $scope.userDetails.config.theme;
        };
        
        $scope.updateDefaultLog = function() {
            $scope.userDetails.config.defaultLog = $scope.defaultLogId;
            return $http.patch($scope.userDetails._links.self.href, {
                config: { defaultLog: $scope.defaultLogId }
            });
        }
        
        $scope.updateDefaultNoteEntry = function () {
            $scope.userDetails.config.defaultNoteEntry = $scope.defaultNoteEntry;
            pushUserConfigToAppState();
            return $http.patch($scope.userDetails._links.self.href, {
                config: { defaultNoteEntry: $scope.defaultNoteEntry }
            });
        }
        
        $scope.initFields = function() {
        $scope.userFields = [
           {
              key: "firstName",
              type: "input",
              templateOptions: {
                 label: 'First Name',
                 placeholder: 'First Name',
                 required: true
              }
           },
           {
              key: "lastName",
              type: "input",
              templateOptions: {
                 label: 'Last Name',
                 placeholder: 'Last Name',
                 required: true
              }
           },
           {
              key: 'newPassword',
              type: 'input',
              model: $scope.userDetails,
              hideExpression: function($viewValue, $modelValue, scope ) {
                 var res = scope.$parent.$parent.hasExclusiveLogin;
                 return res;
              },
               validators: {
                  password: {
                      expression: function(value) {
                          // If the field has not been used for input, allow to continue.
                          if (typeof value !== 'string') return true;

                          if (!(/.*[a-z]/g).test(value)) {
                              return false;
                          }
                          if (!(/.*[A-Z].*/g).test(value)) {
                              return false;
                          }
                          if (!(/.[0-9].*/g).test(value)) {
                              return false;
                          }
                          if (!(/.{8,}/g).test(value)) {
                              return false;
                          }
                          return true;
                      }
                  }
               },
               validation: {
                  messages: {
                      password:  () => 'Password must be more than 8 characters, contain an upper and lower case letter and a number.',
                  }
               },
              templateOptions: {
                type: 'password',
                label: 'Password',
                placeholder: 'Change Password, 8 character minimum',
                minlength: 8
              }
            
           }, 
           {
              key: 'config.theme',
              type: 'select',
              model: $scope.userDetails,
              templateOptions: {
                label: 'Display Theme',
                placeholder: 'Select',
                onChange: $scope.updateTheme,
                options: $scope.themes
              }
            
           }
           
        ];
        };
        
        $scope.toggleNotifications = function(email)
        {
           email.receiveNotifications = !email.receiveNotifications;
           $http.patch(email._links.self.href, {
              "receiveNotifications": !email.receiveNotifications
           }).then(function(result) {
              email.receiveNotifications = result.data.receiveNotifications;
           });
        };
        
        $scope.controlTypeOptions = [
            {display: 'Default', value: null},
            {display: 'Bottom Bar', value: 'BAR'},
            {display: 'Popup', value: 'DIALOG'},
            {display: 'Fullscreen', value: 'FULLSCREEN'},
            {display: 'Enter Notes Page', value: 'ENTER_NOTES'}
        ];
    
        $scope.defaultNoteEntry = null;
        
        function validateNoteControlType(value) {
            return $scope.controlTypeOptions.map(op => op.value).some(v => v === value) ? value : null;
        }
        
        function pushUserConfigToAppState() {
            appStateService.currentUser.config = $scope.userDetails.config;
        }
        
  }]);